// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-available{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin-top:100px}.not-available p{font-family:\"GothamSSm-Medium\",Arial,sans-serif;font-size:20px;color:#a9a9a9}\n", ""]);
// Exports
module.exports = exports;
